import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { memoizeWithToken } from 'api/utils/memoizeUtils';

export const ENVIRONMENTS = Object.freeze({
  DEV: 'dev',
  INTEGRATION: 'int',
  QA: 'qa',
  PRODUCTION: 'prod'
});

export function getConfig() {
  const URL = '/infrastructure/config';
  return axios
    .post(URL)
    .then(({ data }) => data)
    .then(({ data }) => data);
}

export const getConfigSettings = memoizeWithToken(() =>
  from(axios.post('/infrastructure/config/getSettings')).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  )
);

export const getSystemPublicOption = (payload) => {
  return from(axios.post('/infrastructure/config/public/getSystemOption', payload)).pipe(
    map(({ data: { data, success } }) => ({ data, success }))
  );
};
